import { useStudio } from '@/features/studio/contexts/StudioContext';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import { ShieldOff } from 'lucide-react';

export function SuspendedScreen() {
  const { signOut } = useAuth();
  const { membership } = useStudio();

  if (!membership || membership.isOwner || membership.status !== 'archived') return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background p-6">
      <div className="max-w-sm w-full text-center space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-destructive/10 flex items-center justify-center mx-auto">
          <ShieldOff size={28} className="text-destructive" />
        </div>
        <div className="space-y-2">
          <h2 className="text-xl font-bold font-display">Compte suspendu</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Votre accès au studio <strong>{membership.studioName}</strong> a été suspendu par le propriétaire.
            Contactez-le pour plus d'informations.
          </p>
        </div>
        <button
          onClick={() => signOut()}
          className="w-full py-3 bg-secondary text-secondary-foreground rounded-xl font-semibold hover:bg-secondary/80 transition-colors"
        >
          Se déconnecter
        </button>
      </div>
    </div>
  );
}
